import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';

/**
 * The list of tabs on this page
 */
export enum ConfigurationCommitmentsPageTabId {
	Commitments = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum ConfigurationCommitmentsPageViewId {
	Commitments = 1,
}


@Injectable({ providedIn: 'root' })
export class ConfigurationCommitmentsService extends PageTabsLayoutPageService<ConfigurationCommitmentsPageTabId, ConfigurationCommitmentsPageViewId> {
	private static readonly _viewDroplistItems: DroplistItem<never, ConfigurationCommitmentsPageViewId>[] = [
		{
			uniqueId: ConfigurationCommitmentsPageViewId.Commitments,
			iconContext: {
				iconClass: 'fa-grid',
				iconStyle: 'fa-solid',
				text: 'Commitments',
				hideText: 'never',
			}, customSort: '1-Commitments-2'
		},

	];
	constructor() {
		super(ConfigurationCommitmentsService._viewDroplistItems, ConfigurationCommitmentsService.name, ConfigurationCommitmentsPageTabId.Commitments, ConfigurationCommitmentsPageViewId.Commitments);
	}

	public get viewId() {
		return ConfigurationCommitmentsPageViewId;
	}
}